<template>
  <div id="mainWps" class="wps-wrap">

  </div>
</template>

<script setup>
/*
 * Excel在线预览通用组件，全部指向这里
 */
import CryptoJS from "crypto-js";

const props = defineProps({
  ossPath: {
    type: String,
    required: true,
  },
  officeType:{
    type: String,
    default: WebOfficeSDK.OfficeType.Spreadsheet
  }
})

let instance = null

function initWps() {
  const oss = props.ossPath
  const officeType = props.officeType;
  const fileId = CryptoJS.MD5(oss).toString() // md5作为fileId
  nextTick(() => {
    const config = {
      officeType: officeType,
      mount: '#mainWps',
      appId: (location.host.indexOf('localhost') > -1 || location.host.indexOf('wwwpre') > -1) ? 'SX20241219TAAFZZ' : 'AK20241226DJGDWQ',
      fileId: toRaw(fileId),
      customArgs: { // 参数，会传入到后端
        "scene": "preview",
        "fileUrl": oss,
        isView: 1
      },
    }
    console.log('传入wps配置信息', config)
    instance = WebOfficeSDK.init(config)
  })
}


onMounted(() => {
  initWps()
})

onBeforeUnmount(() => { // 销毁实例
  if (instance != null) {
    instance.destroy()
    instance = null
  }
})

</script>

<style scoped>
.wps-wrap {
  height: 100%;
}
</style>
